import React from "react"
import * as utils from "../../../helpers/utils"
import { ITimeoffRequestDocument } from "../../../models"
import "./styles.css"
import * as leaveRequestHelper from "../../../helpers/leaveRequestHelper"
import strings from "../../../localization/strings"
import { green800 } from "material-ui/styles/colors"
export interface ILeaveRequestEvent {
	start: Date
	end: Date
	leaveRequest?: ITimeoffRequestDocument
	holidayName?: string
	handleUpdate?(leaveRequest: ITimeoffRequestDocument): void
	onRightClick?(leaveRequest: ITimeoffRequestDocument, e: React.MouseEvent<HTMLElement>): void
}
interface IProps {
	event: ILeaveRequestEvent
}

export const MonthEvent: React.SFC<IProps> = (props: IProps) => {
	if (props.event.leaveRequest) {
		const handleClick = (e: React.MouseEvent<HTMLElement>) => {
			if (e.nativeEvent.button === 2) {
				e.preventDefault()
				props.event.onRightClick(props.event.leaveRequest, e)
			}
			else {
				props.event.handleUpdate(props.event.leaveRequest)
			}
		}
		const background = leaveRequestHelper.getColor500ByTimeoffStatus(props.event.leaveRequest.Status)
		return (
			<div
				className="LeaveCalendar-Event"
				style={{ background }}
				onClick={handleClick}
				onContextMenu={handleClick}
			>
				<span className="LeaveCalendar-EventTime">{`${props.event.leaveRequest.HoursPerDay}${strings.HoursAbbreviation}`}</span>
				<div
					className="LeaveCalendar-EventName TextOverflow"
					style={{ background: utils.getMaterial900ColorFrom500Color(background) }}
					title={props.event.leaveRequest.EmployeeName}
				>
					{props.event.leaveRequest.EmployeeName}
				</div>
			</div>
		)
	}
	else {
		return (
			<div
				className="LeaveCalendar-Event"
				style={{ background: green800, display: "flex", alignItems: "center", justifyContent: "center" }}
			>
				{props.event.holidayName}
			</div>
		)
	}
}